import CountReducer from './CountReducer';
import SumReducer from './SumReducer';
import AverageReducer from './AverageReducer';
import MaxReducer from './MaxReducer';
import MinReducer from './MinReducer';

const reducers = {
  COUNT: CountReducer,
  SUM: SumReducer,
  AVG: AverageReducer,
  MIN: MinReducer,
  MAX: MaxReducer
};

export default reducers;
